var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"parent":"clients_base","subparent":{
      route: ("/clients_base/" + (_vm.$route.params.id)),
      content: _vm.client_name,
    }}}),_c('IQOSTable',{attrs:{"rows":_vm.orders,"cols":[
      {
        title: '#',
        index: true,
      },
      {
        title: _vm.$t('worker_tips_history.col_date'),
        key: 'created_at',
        date: true,
        width: 200,
      },
      {
        title: _vm.$t('worker_tips_history.col_time'),
        key: 'created_at',
        time: true,
        width: 160,
      },
      {
        title: _vm.$t('subscription.transactions.system'),
        key: 'mode',
        renderer: function (row) { return _vm.formatSystemName(row.mode); },
      },
      {
        title: _vm.$t('worker_tips_history.col_total'),
        key: 'total',
        width: 160,
        currency: 'symbol',
      },
      {
        title: _vm.$t('worker_tips_history.col_discount'),
        key: 'discount',
        default: '0',
        unit: '%',
      } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }